import { WithChildren } from "helpers";
import React, { FC } from "react";

interface Props {
  onClick: () => void;
  className?: string;
  style?: any;
}

const SpanEvent: FC<Props & WithChildren> = ({
  onClick,
  className,
  children,
  style
}) => {
  return (
    <div
      className={className}
      onClick={onClick}
      tabIndex={0}
      role="button"
      style={style}
    >
      {children}
    </div>
  );
};

export default SpanEvent;
